import React from 'react';

interface Pillar {
  num: string;
  title: string;
  question: string;
  description: string;
  features: string[];
}

const DecisionSection: React.FC = () => {
  const pillars: Pillar[] = [
    {
      num: '01',
      title: 'Simulation',
      question: 'Will your expansion be profitable?',
      description: 'Before you commit, see month by month how your revenue builds, when your costs peak, and exactly when you could turn profitable. Modelled on your company, your market, your numbers.',
      features: ['Conservative, base, and optimistic paths', 'Month-by-month cash flow projection', 'Break-even point for your specific case']
    },
    {
      num: '02',
      title: 'Costs',
      question: 'What will it really cost you?',
      description: 'See what every position you plan to hire actually costs in your target market. Real salaries, local taxes, setup fees, and operational costs — so the budget you commit to is the budget you actually need.',
      features: ['Hiring plan with local salary benchmarks', 'Employer taxes, insurance, compliance', 'Total capital required to profitability']
    },
    {
      num: '03',
      title: 'Comparison',
      question: 'Is there a better market?',
      description: 'We automatically compare your target against multiple similar markets so you can see which ones offer faster profitability, lower costs, and less risk.',
      features: ['Alternative markets ranked by score', 'Side-by-side revenue and profitability', 'Recommendation on where to expand first']
    }
  ];

  return (
    <div className="section decision-section">
      <div className="section-label"><span>Your Market Entry Decision Starts Here</span></div>
      <h2 className="section-title">Everything you need to know<br /><em>Before you decide on a new market.</em></h2>
      <p className="section-sub">Most companies expand based on assumptions. We give you a clear picture of what your expansion will actually look like so you make the right call from day one.</p>
      <div className="pillars">
        {pillars.map((pillar, index) => (
          <div key={index} className="pillar">
            <div className="pillar-num">{pillar.num} · {pillar.title}</div>
            <h3>{pillar.question}</h3>
            <p>{pillar.description}</p>
            <div className="pillar-divider"></div>
            <ul className="pillar-list">
              {pillar.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DecisionSection;
